// @flow

import * as React from 'react';
import { withRouter } from 'react-router-dom';
import SliderElement from './SliderElement';

type Props = {
  children: React.Node,
  updateCurrentSlide: Function,
  location: Location,
  goTopOnUpdate?: boolean,
  disableUrlUpdate: boolean,
  selectedIndex: number,
}

type State = {
  selectedIndex: number
}

class Slider extends React.Component<Props, State> {
  static defaultProps = {
    goTopOnUpdate: false,
  };

  state: State = {
    selectedIndex: this.props.selectedIndex,
  };

  componentDidMount() {
    if (!this.props.disableUrlUpdate) {
      this.updateUrl();
    }
  }

  componentDidUpdate(prevProps: Props, prevState: State, snapshot: any) {
    if (this.props.location.pathname !== prevProps.location.pathname
      && !this.props.disableUrlUpdate) {
      this.updateUrl();
    }
  }

  updateUrl = () => {
    const children = React.Children.toArray(this.props.children);
    for (let i = 0; i < children.length; i++) {
      // TODO: manage regex url
      if (this.props.location.pathname.startsWith(children[i].props.path)) {
        if (this.state.selectedIndex !== i && this.props.goTopOnUpdate) {
          for (let y = 0; y < document.getElementsByClassName('scrollable-content').length; ++y) {
            document.getElementsByClassName('scrollable-content')[y].scrollTop = 0;
          }
        }
        this.setState({ selectedIndex: i });
        this.props.updateCurrentSlide(i);
        break;
      }
    }
  };

  render() {
    const children = React.Children.toArray(this.props.children);
    return (
      <div className="slider">
        <div style={{
          height: '100%',
          width: `${children.length * 100}%`,
          transition: 'transform .2s cubic-bezier(0,.46,.45,.99),-webkit-transform .2s cubic-bezier(0,.46,.45,.99)',
          transform: `translate3d(${-(this.props.disableUrlUpdate ? this.props.selectedIndex : this.state.selectedIndex) * (100 / children.length)}%, 0px, 0px)`,
        }}
        >
          {
            children.map((child, index) => (
              (this.props.disableUrlUpdate || child.type === SliderElement)
              && (
                <div
                  className={`${index === (this.props.disableUrlUpdate ? this.props.selectedIndex : this.state.selectedIndex) ? 'active' : ''}`}
                  key={
                    // $FlowFixMe
                    child.key
                  }
                  style={{
                    height: '100%',
                    width: `${100 / children.length}%`,
                    float: 'left',
                    position: 'relative',
                  }}
                >
                  {
                    // $FlowFixMe
                    child
                  }
                </div>
              )
            ))
          }
        </div>
      </div>

    );
  }
}

export default withRouter(Slider);
